import { datadogRum } from '@datadog/browser-rum';

export const storeOfflineEvent = (): void => {
  const offlineData = {
    offlineTimestamp: new Date(),
    url: window.location.href,
  };

  localStorage.setItem('offlineTracker', JSON.stringify(offlineData));
};

export const sendOfflineEvents = (): void => {
  const offlineData = localStorage.getItem('offlineTracker');

  if (offlineData !== null && navigator?.onLine) {
    const { offlineTimestamp, url } = JSON.parse(offlineData);
    const onlineTimestamp = new Date();

    datadogRum.addAction('offlineEventTracked', {
      offlineTimestamp: new Date(offlineTimestamp),
      onlineTimestamp,
      url,
    });

    localStorage.removeItem('offlineTracker');
  }
};
